import { type LocaleEnum, RTL_LANGUAGES } from '@unifyapps/i18n/const';
import { useLanguageContext } from '@unifyapps/i18n/context/LanguageProvider';
import { useCallback } from 'react';

export const useIsRtl = () => {
  const language = useLanguageContext();

  return RTL_LANGUAGES.has(language as LocaleEnum);
};

export const useLocaleDirection = () => {
  const isRtl = useIsRtl();
  // Sometimes dir set on html element wont be valid for actual locale which is being rendered.
  // Eg. user locale could be ltr, but in some components content could be of rtl language, so we need to use this hook to set the "dir" of detached components
  // like modal/drawer properly. Rest components will use the "dir" set on nearest parent element.
  return isRtl ? 'rtl' : 'ltr';
};

export const useGetRtlAwareOrientation = () => {
  const isRtl = useIsRtl();

  const getRtlAwareOrientation = useCallback(
    (orientation: string | undefined) => {
      if (isRtl) {
        if (orientation === 'left') {
          return 'right';
        } else if (orientation === 'right') {
          return 'left';
        }
      }
      return orientation;
    },
    [isRtl],
  );

  return { getRtlAwareOrientation };
};
